export default "__VITE_ASSET__B6zbJV9g__"